import { createSlice } from '@reduxjs/toolkit';

export interface DocsDataState {
  data: {
    guidesTree: any;
    docsTree: any;
  };
  status: 'idle' | 'loading' | 'failed';
}

const initialState: DocsDataState = {
  data: {
    guidesTree: {},
    docsTree: {},
  },
  status: 'idle',
};

export const docsDataSlice = createSlice({
  name: 'docsTree',
  initialState,
  reducers: {},
});

export default docsDataSlice.reducer;
